import {
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpErrorResponse,
    HttpEvent
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, catchError, throwError, firstValueFrom } from 'rxjs';
import { SessionExpiredDialogComponent } from '../components/session.dialog.component';
import { AuthSessionService } from './auth-session.service';

/** Flag to prevent multiple simultaneous expiry dialogs */
let isDialogOpen = false;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private dialog = inject(MatDialog);
    private router = inject(Router);
    private authSessionService = inject(AuthSessionService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const modifiedReq = req.clone({ withCredentials: true });

        return next.handle(modifiedReq).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    const isCheckSession = req.url.includes('/verify');
                    const isLoginPage = this.router.url.includes('/login');
                    const isLogoutApi = req.url.includes('/auth/logout');
                    const isPasswordResetApi = req.url.includes('/auth/forgot-password') || req.url.includes('/auth/reset-password');
                    const isLoginApi =
                        req.url.includes('/auth/token') ||
                        req.url.includes('/login');

                    // /verify failure should only auto-logout when already inside the app
                    if (isCheckSession && !isLoginPage) {
                        this.authSessionService.handleRemoteLogout();
                        return throwError(() => error);
                    }

                    // Do not show session-expired popup during login/logout/takeover flow
                    if (isLoginPage || isLogoutApi || isLoginApi || isCheckSession || isPasswordResetApi) {
                        return throwError(() => error);
                    }

                    if (!isDialogOpen) {
                        isDialogOpen = true;

                        this.authSessionService.broadcastLogout('ALL');

                        firstValueFrom(
                            this.dialog.open(SessionExpiredDialogComponent, {
                                disableClose: true,
                                panelClass: 'sweet-alert-style'
                            }).afterClosed()
                        ).then(() => {
                            isDialogOpen = false;
                            this.dialog.closeAll();
                        });
                    }
                }

                return throwError(() => error);
            })
        );
    }
}